import {inlineError} from '@s-ui/decorators'
import {Service} from '@s-ui/domain'

export class GetLastContactDetailsSellerService extends Service {
  /**
   * @constructor
   * @param {Object} deps
   * @param {SellerRpository} deps.sellerRepository
   */
  constructor({sellerRepository}) {
    super({sellerRepository})

    this._sellerRepository = sellerRepository
  }

  @inlineError
  async execute() {
    const [error, contactDetailsVO] = await this._sellerRepository.getLastContactDetails()

    if (error) {
      return Promise.reject(error)
    }

    return contactDetailsVO
  }
}
